import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/monthly-cloud/flat/web/layouts/default.vue").then(m => m.default || m)),
  embed: defineAsyncComponent(() => import("/builds/monthly-cloud/flat/web/layouts/embed.vue").then(m => m.default || m))
}